/* eslint-disable react/no-unused-state */
/* eslint-disable max-classes-per-file */
import React from "react";
import "react-dates/initialize";
import { CalendarToday } from "@material-ui/icons";
import { DateRangePicker, SingleDatePicker, isInclusivelyBeforeDay } from "react-dates";
import "react-dates/lib/css/_datepicker.css";
import moment from "moment";
import DateTime from "react-datetime";
import "./dateRangeStylesReset.scss";

export class DatePicker extends React.Component {
  constructor(props) {
    super(props);
    const { date, todaySelectable } = this.props;
    this.state = {
      date,
      focused: null,
    };
    const m = moment(new Date());
    if (todaySelectable) {
      this.lastSelectableDay = m;
    } else {
      this.lastSelectableDay = m.subtract(1, "day");
    }
  }

  static getDerivedStateFromProps(props) {
    return { date: props.date };
  }

  render() {
    const {
      className, label, onDateChange,
    } = this.props;
    const {
      date, focused,
    } = this.state;
    return (
      <div className={`single-date-picker-container ${className}`}>
        <SingleDatePicker
          placeholder={label || "Select Date"}
          date={date}
          focused={focused}
          isOutsideRange={(day) => !isInclusivelyBeforeDay(day, this.lastSelectableDay)}
          onDateChange={(dt) => {
            this.setState({ date: dt });
            onDateChange(dt);
          }}
          displayFormat="D MMM YYYY"
          numberOfMonths={1}
          onFocusChange={(focusedInput) => {
            this.setState({ focused: focusedInput.focused });
          }}
          customInputIcon={<CalendarToday />}
          inputIconPosition="after"
        />
      </div>
    );
  }
}

export class RangePicker extends React.Component {
  constructor(props) {
    super(props);
    const { startDate, endDate, monthsToDisplay } = this.props;
    this.state = {
      startDate,
      endDate,
      numberOfMonths: monthsToDisplay,
      focusedInput: null,
    };
    const m = moment(new Date());
    this.lastSelectableDay = m;
  }

  onDateChange = ({ startDate, endDate }) => {
    const { onDatesChange } = this.props;
    const { focusedInput } = this.state;
    this.setState({ startDate, endDate });
    if (focusedInput === "endDate") onDatesChange({ startDate, endDate });
    if (focusedInput === "startDate") this.setState({ endDate: null });
  };

  render() {
    const {
      numberOfMonths, startDate, endDate, focusedInput: focusedInputState,
    } = this.state;
    const { rangeLimit } = this.props;
    return (
      <DateRangePicker
        startDateId="startDate"
        numberOfMonths={numberOfMonths}
        endDateId="endDate"
        startDate={startDate}
        endDate={endDate}
        minimumNights={0}
        isOutsideRange={(day) => {
          if (rangeLimit) {
            if (startDate && !endDate) {
              // Limit selection to rangeLimit days from the start date
              const diffInDays = day.diff(startDate, "days");
              return diffInDays < 0
                || diffInDays > rangeLimit
                || !isInclusivelyBeforeDay(
                  day,
                  moment(startDate).add(rangeLimit - 1, "days") > this.lastSelectableDay
                    ? this.lastSelectableDay
                    : moment(startDate).add(rangeLimit - 1, "days"),
                );
            }
          }
          return !isInclusivelyBeforeDay(day, this.lastSelectableDay);
        }}
        // eslint-disable-next-line no-shadow
        onDatesChange={({ startDate: sDate, endDate: eDate }) => {
          this.onDateChange({ startDate: sDate, endDate: eDate });
        }}
        focusedInput={focusedInputState}
        onFocusChange={(focusedInput) => {
          this.setState({ focusedInput });
        }}
        displayFormat="D MMM YYYY"
      />
    );
  }
}

export class SingleDateTimePicker extends React.Component {
  constructor(props) {
    super(props);
    const { date } = this.props;
    this.state = {
      date,
    };
    this.valid.bind(this);
  }

  valid = (current) => {
    const { date } = this.props;
    return current.isBefore(date);
  };

  render() {
    const { onDateChange } = this.props;
    return (
      <DateTime
        isValidDate={this.valid}
        inputProps={({ placeholder: "Select Date" }, { readOnly: true })}
        onChange={(date) => {
          this.setState({ date });
          onDateChange(date);
        }}
      />
    );
  }
}
